import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'flash_sales-sale_announcement_tooltip-click';

/**
 * Tracks clicks on sale announcement tooltip cta
 */
export function trackFlashSalesSaleAnnouncementTooltipClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
